import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, P, Stack, Text, useText } from "@sveabank/cc-common";
import Paper from "../../../../components/paper";
import type { ClcShareholder } from "../../../../types/clc-application";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	person: ClcShareholder;
	deleteShareholder: (nationalId: string) => void;
};

export const DeleteShareholderModal = ({ open, setOpen, person, deleteShareholder }: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog
			isOpen={open}
			setOpen={setOpen}
			icon="error"
			center
			size="small"
			heading={t(texts.newCompany.shares.deleteShareholderModalHeading)}
		>
			<Dialog.Content>
				<Stack gap={4}>
					<Stack gap={2}>
						<Text align="start">{t(texts.newCompany.shares.deleteShareholderModalText)}</Text>
					</Stack>

					<Paper className="bg-background-tertiary">
						<Text align="left">
							<Text component="p" bold>
								{person.firstName} {person.lastName}
							</Text>
							<P>{person.postalAddress}</P>
							<P>
								{person.postCode} {person.town}
							</P>
						</Text>
					</Paper>
				</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button
						onPress={() => {
							deleteShareholder(person.nationalId);
						}}
					>
						{t(texts.common.remove)}
					</Button>
					<Button variant="secondary" onPress={() => setOpen(false)}>
						{t(texts.common.abort)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
